export default {
  methods: {
    submit(e, id, config) {
      if (!e._constructed || !id) return
      window.WeiyiStatSDK && window.WeiyiStatSDK.submit(id, config)
    }
  }
};